<div
    (click)="click()"
    class="w-full cursor-pointer"
    [attr.data-testid]="id()"
    [attr.data-styletarget]="id()"
>
    <h3
        [attr.data-testid]="id() + '-data-info'"
        [attr.data-styletarget]="id() + '-data-info'"
        [attr.data-uitype]="'title-h3'"
        [datiqTemplateMd]="dataInfoMci()"
        class="font-body-2 mb-4"
    ></h3>

    @if(!noDataMci()){ @if((loadedMci()) && !errorMci()){

    <div
        class="h-2 flex divide-x divide-white"
        [attr.data-testid]="id() + '-gauge'"
        [attr.data-styletarget]="id() + '-gauge'"
        [attr.data-uitype]="'viz-bar'"
    >
        @for (step of steps(); track i; let i = $index; let last =
        $last){
        <div
            class="relative"
            [attr.data-testid]="id() + '-gauge-step-' + i"
            [attr.data-styletarget]="id() + '-gauge-step-' + i"
            [attr.data-uitype]="'viz-bar-step'"
            [style.width.%]="
                { low: 0, high: 1 / steps().length, scenario: scenario() }
                    | mcGaugeMciStep
            "
            [style.margin-right.px]="last ? 0 : 4"
            [style.background]="step.color"
        >
            @if(gaugeMarkerPositionIndex() === step?.index){
            <div
                [style.background]="step?.color"
                [style.top.px]="-4"
                [style.left]="'calc(' + gaugeMarkerPosition() + '% - 12px)'"
                [style.border-radius.px]="99999"
                class="absolute h-4 w-4 z-9"
            ></div>
            <mat-icon
                [style.top.px]="-8"
                [style.left]="'calc(' + gaugeMarkerPosition() + '% - 16px)'"
                [style.border-radius.px]="99999"
                class="absolute font-bold material-symbols-outlined z-10"
            >
                circle
            </mat-icon>
            }
        </div>

        }
    </div>
    } @else {
    <div
        class="h-2 flex divide-x divide-white"
        [attr.data-testid]="id() + '-gauge-loading'"
        [attr.data-styletarget]="id() + '-gauge-loading'"
        [attr.data-uitype]="'loader'"
    >
        @for (step of steps(); track i; let i = $index; let last =
        $last){
        <div
            [style.width.%]="
                { low: 0, high: 1 / steps().length, scenario: 'unweighted' }
                    | mcGaugeMciStep
            "
            [style.margin-right.px]="last ? 0 : 4"
            [class.animate-pulse]="!errorMci()"
            class="bg-dat-grey-300"
            [style.animation-delay.ms]="i * 200"
        ></div>
        }
    </div>
    }
    <label
        [attr.data-testid]="id() + '-label-loads'"
        [attr.data-styletarget]="id() + '-label-loads'"
        [attr.data-uitype]="'label'"
        class="font-caption-micro text-dat-grey-500 w-1/2 inline-block text-left"
    >
        {{ lowLabel() }}
    </label>
    <label
        [attr.data-testid]="id() + '-label-trucks'"
        [attr.data-styletarget]="id() + '-label-trucks'"
        [attr.data-uitype]="'label'"
        class="font-caption-micro text-dat-grey-500 text-right inline-block w-1/2"
    >
        {{ highLabel() }}
    </label>
    } @else {
        <label class="label-strong text-dat-text-secondary">MCI currently not available</label>
    }
</div>
